import PropTypes from 'prop-types';
import React from 'react';
import { moveCaretAtEnd } from '../../../common/helpers/inputs';
import SimpleCurrencyInput from '../../../common/SimpleCurrencyInput';
import { t } from '../../../../modules/infra/i18n';

const CustomCashOption = ({
  active,
  setActive,
  onSubmit,
  onChange,
  value,
  disabled,
}) => {
  if (!active) {
    return (
      <button
        type="button"
        className="c-cash-options__item"
        onClick={setActive}
        data-automation-id="button:cashOption:Custom"
      >
        {t('register:payment.custom_cash_option.custom')}
      </button>
    );
  }
  return (
    <form
      onSubmit={onSubmit}
      className="c-cash-options__item"
    >
      <div>
        <div className="delta u-pb-">{t('register:payment.custom_cash_option.custom')}</div>
        <SimpleCurrencyInput
          wrapperClassName=""
          precision={2}
          className="c-input"
          placeholder={t('register:payment.custom_cash_option.enter_amount')}
          onInputChange={onChange}
          type="tel"
          onInputFocus={moveCaretAtEnd}
          value={value}
          autoFocus
          dataAutomationId="input:customCashAmount"
        />
        <button
          className="c-link-button u-type--uppercase u-type--semibold u-fontsize-tiny u-mt-"
          type="submit"
          disabled={disabled}
          data-automation-id="button:applyCustomCash"
        >
          {t('register:payment.custom_cash_option.apply')}
        </button>
      </div>
    </form>
  );
};
CustomCashOption.propTypes = {
  active: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default CustomCashOption;
